/**
 * Base size in pixels used for scaling various UI elements in the audiogram.
 * This value is used as a reference for calculating other dimensions like padding, margins, and component sizes.
 */
export const BASE_SIZE = 40;

/**
 * Font weight for the captions text, making it bold and more readable.
 * Value of 600 corresponds to semi-bold weight.
 */
export const CAPTIONS_FONT_WEIGHT = 600;

/**
 * Font size for the captions text, calculated relative to the base size.
 * This ensures consistent scaling of text across different audiogram sizes.
 */
export const CAPTIONS_FONT_SIZE = 1.5 * BASE_SIZE;

/**
 * Line height for the captions text, providing proper vertical spacing between lines.
 * This value is used to ensure readable text layout and proper line breaks.
 */
export const LINE_HEIGHT = 2 * BASE_SIZE;

/**
 * Maximum number of caption lines that can be displayed on a single page.
 * This controls how many lines of text are visible at once in the audiogram.
 */
export const LINES_PER_PAGE = 5;

/**
 * Frames per second for the audiogram video.
 * This value determines the smoothness of animations and the overall video quality.
 */
export const FPS = 30;
